import { useTranslation } from 'react-i18next';
import { LayoutDashboard } from 'lucide-react';

export function BoardNoViewsEmptyState() {
  const { t } = useTranslation('boards');

  return (
    <div
      className="flex h-full flex-col items-center justify-center gap-4 py-16"
      data-testid="boards-no-views-empty-state"
    >
      <div className="rounded-full bg-muted p-4">
        <LayoutDashboard className="h-8 w-8 text-muted-foreground" />
      </div>
      <div className="text-center">
        <h3 className="text-lg font-medium">{t('views.empty')}</h3>
        <p className="mt-1 text-sm text-muted-foreground">{t('views.emptyDescription')}</p>
      </div>
    </div>
  );
}
